(function(){
  /* ---------- 1. Morphing glass behind the desktop mega menu ---------- */
  function initMenu(){
    var nav = document.querySelector('[data-brf-mm]');
    if (!nav || nav.__brfApple) return;
    nav.__brfApple = true;
    var bg = document.createElement('div');
    bg.className = 'brf-mm__bg';
    bg.setAttribute('aria-hidden', 'true');
    nav.appendChild(bg);
    var items = nav.querySelectorAll('.brf-mm__item');
    function sync(){
      var li = nav.querySelector('.brf-mm__item.is-open');
      var panel = li && li.querySelector('.brf-mm__panel');
      var h = panel ? panel.offsetHeight + 'px' : '0px';
      if (bg.style.height !== h) bg.style.height = h;
      /* only touch the class when it actually changes */
      if (nav.classList.contains('is-flyout') !== !!panel) nav.classList.toggle('is-flyout', !!panel);
    }
    /* watch just the menu items (not the nav itself), so our own class change can't re-trigger this */
    var mo = new MutationObserver(sync);
    for (var i = 0; i < items.length; i++) mo.observe(items[i], {attributes: true, attributeFilter: ['class']});
    window.addEventListener('resize', sync, {passive: true});
  }

  /* ---------- 2. Filter bar pinned under the header ---------- */
  function initFilters(){
    var bar = document.querySelector('[data-brf-fbar]');
    if (!bar || bar.closest('.brf-fstick')) return;
    var sec = bar.closest('.shopify-section');
    if (!sec || !sec.parentElement) return;

    /* Sticky only works inside a tall parent. If the bar already shares a wrapper with the
       products (search page), pin it right there; otherwise (collection head) move it to
       just after its section so it can ride down the whole product grid. */
    var host = null, ref = null, inPlace = false;
    for (var a = bar.parentElement; a && a !== sec; a = a.parentElement) {
      if (a.querySelector('.product-item, .product-list')) { host = a; break; }
    }
    if (host) {
      ref = bar;
      while (ref.parentElement !== host) ref = ref.parentElement;
      inPlace = true;
    } else {
      host = sec.parentElement;
      ref = sec.nextSibling;
    }

    var sentinel = document.createElement('div');
    sentinel.className = 'brf-fstick__sentinel';
    var shell = document.createElement('div');
    shell.className = 'brf-fstick';
    var inner = document.createElement('div');
    inner.className = inPlace ? 'brf-fstick__in' : 'container brf-fstick__in';
    host.insertBefore(sentinel, ref);
    host.insertBefore(shell, ref);
    inner.appendChild(bar);
    shell.appendChild(inner);

    var hdr = document.getElementById('shopify-section-header') || document.querySelector('.shopify-section__header');
    var root = document.documentElement;
    function headerOffset(){
      if (!hdr) return 0;
      var pos = getComputedStyle(hdr).position;
      /* a negative sticky top (slim desktop header) means only part of the header stays on screen */
      return (pos === 'sticky' || pos === 'fixed') ? hdr.offsetHeight + Math.min(0, parseFloat(getComputedStyle(hdr).top) || 0) : 0;
    }
    var top = 0;
    function measure(){
      top = headerOffset();
      root.style.setProperty('--brf-stick-top', top + 'px');
      check();
    }
    function check(){
      var stuck = sentinel.getBoundingClientRect().top < top - 0.5;
      shell.classList.toggle('is-stuck', stuck);
    }
    measure();
    window.addEventListener('scroll', check, {passive: true});
    window.addEventListener('resize', measure, {passive: true});
    if (window.ResizeObserver && hdr) new ResizeObserver(measure).observe(hdr);
  }

  function init(){ initMenu(); initFilters(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
})();
